<div class="text-right">
  <gung-button classes="btn-primary btn-sm" label="{{ 'CREATE_NOTE' | translate }}" [onClick]="create.bind(this)" />
</div>
<lib-filter-list [configService]="hubspotActivitiesConfigService"></lib-filter-list>
